import { get, patch, post } from './client';
import { ROUTES } from './config';
import type { ApiEnvelope, Location } from '@/types/types';

export const locationsApi = {
    list: () => get<ApiEnvelope<Location[]>>(ROUTES.LOCATIONS_LIST),
    byCompany: (companyId: string) =>
        get<ApiEnvelope<Location[]>>(ROUTES.LOCATIONS_LIST, {
            params: { company_id: companyId },
        }),
    byId: (id: string) => get<ApiEnvelope<Location>>(ROUTES.LOCATION(id)),
    create: (payload: Partial<Location>) =>
        post<ApiEnvelope<Location>>(ROUTES.LOCATION_CREATE, payload),
    update: (id: string, payload: Partial<Location>) =>
        patch<ApiEnvelope<Location>>(ROUTES.LOCATION_UPDATE(id), payload),
};
